export default __webpack_public_path__ + "262bbe97bab4451a8bdecf75144696c0.svg";